import N8nCircleLoader from './CircleLoader.vue';

export default N8nCircleLoader;
